<template>
  <div>
    <!-- 重量修改 -->
    <el-dialog :title="$t('message.modificationOfWeigh')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="480px" center>
      <div class="content">
        <!-- 重量(kg)： -->
        <div class="label">{{ $t("message.weight") }}(kg) ：</div>
        <div class="val">
          <el-input v-model="weight" onfocus="this.select()" type="number"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import { mapState } from "vuex";
export default {
  props: {
    ids: { type: Array },
  },
  data() {
    return {
      weight: "",
      porder_sn: this.$route.query.porder_sn,
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState({
      boxIds: (state) => state.porderDetail.boxIds,
    }),
  },
  methods: {
    // 保存
    save() {
      let datas = {
        ids: this.boxIds,
        weight: this.weight,
      };
      if (this.weight == "") return this.$message.error("请输入要修改的重量");
      this.$api.porderApi.modifyBoxWeight(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$store.dispatch("freightList", { porder_sn: this.porder_sn });
        this.$store.commit("setBoxIds", []);
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}
</style>